import React from 'react'
import styled from 'styled-components'

interface Props {
  className?: string
  fontSize?: string
  weight?: number
  color?: string
  lineHeight?: string
  children: React.ReactNode
}

const StyledText = styled.span<Props>`
  font-size: ${({ fontSize }) => fontSize};
  font-weight: ${({ weight }) => `${weight}`};
  color: ${({ theme, color }) => color && theme.global.colors[color]};
  ${({ lineHeight }) => (lineHeight ? `line-height: ${lineHeight}` : null)}
`

export function Text({ className, fontSize = '14px', color = 'white', weight = 400, children, lineHeight }: Props) {
  return (
    <StyledText className={className} weight={weight} fontSize={fontSize} color={color} lineHeight={lineHeight}>
      {children}
    </StyledText>
  )
}
